import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  select: () => ({
    '& > .select-item': {
      '& svg': {
        fill: theme.colors.success.normal,
        verticalAlign: 'middle',
      },
      '&:not(.selected) svg': {
        display: 'none',
      },
      '&.selected .gap': {
        display: 'none',
      },
    },
  }),
}));

export default useStyle;
